import { API_URL } from '../../../app-config/constants';
import { post } from '../request';

const BASE_URL = `${API_URL}`;

export function logout(): Promise<void> {
    return post(`${BASE_URL}/logout`);
}
